import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosHttp from "services/axiosHttp";

// CREATE SUB-CHANNEL ROUTES
export const createSubChannelRoutes = createAsyncThunk("createSubChannelRoutes", async ({ channel_id, id, routes }, { rejectWithValue }) => {
	try {
		const response = await axiosHttp.put(`channel/${channel_id}/sub_channel/${id}/routes`, { routes });
		return response.data;
	} catch (err) {
		if (!err.response) {
			throw err;
		}
		return rejectWithValue(err.response.data);
	}
});

const CreateSubChannelRoutesSlice = createSlice({
	name: "CreateSubChannelRoutesSlice",
	initialState: {
		isLoading: false,
		isError: false,
		error: null,
		data: null,
	},

	reducers: {
		resetCreateSubChannelRoutesState: (state) => {
			state.isLoading = false;
			state.isError = false;
			state.error = null;
			state.data = null;
		},
	},

	extraReducers: (builder) => {
		builder.addCase(createSubChannelRoutes.pending, (state) => {
			state.isLoading = true;
			state.isError = false;
		});

		builder.addCase(createSubChannelRoutes.fulfilled, (state, action) => {
			state.isLoading = false;
			state.isError = false;
			state.data = action.payload;
		});

		builder.addCase(createSubChannelRoutes.rejected, (state, action) => {
			state.isLoading = false;
			state.isError = true;
			state.error = action.payload;
		});
	},
});

export const { resetCreateSubChannelRoutesState } = CreateSubChannelRoutesSlice.actions;
export default CreateSubChannelRoutesSlice.reducer;
